<template>
  <div :class="[
    'footnote-holder',
    {'footnote-holder__inline': isInline}
    ]">
    <template v-if="useFootnoteTooltip">
      <div class="footnotes__svg-holder">
        <div
          v-if="isTooltip"
          class="footnotes__backing"
          @click="isTooltip = false"
        ></div>
        <div v-if="isTooltip" class="footnotes__tool-tip">
          <div class="footnotes__tooltip-scroll-effect-top-bottom">
            <div ref="footnoteTooltipWrapper" class="footnotes__tooltip-wrapper" @scroll.passive="updateScrollEffect($event)">
              <p
                v-for="note of footnotes"
                :key="note + visId"
                v-html="parseNoBreak(note)"
                class="footnote"
              ></p>
            </div>
          </div>
        </div>
        <SvgInfo class="footnotes__svg-info" @click="toggleTooltip()" />
      </div>
      <p v-html="firstFootnote"></p>
    </template>
    <template v-else>
      <p
        v-for="note of footnotes"
        :key="note + visId"
        v-html="parseNoBreak(note)"
        class="footnote"
      ></p>
    </template>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import eventHub from '../eventHub';

import tagParseMixin from '@/mixins/tagParseMixin';

export default {
  mixins: [tagParseMixin],
  components: {
    SvgInfo: () => import('@/assets/svgs/info.svg?inlne'),
  },

  name: 'Footnotes',
  data() {
    return {
      isTooltip: false,
      hideTooltip: null,
    };
  },
  props: {
    visId: {
      type: String,
      default: '',
    },
    visIndex: {
      type: Number,
      required: true,
    },
    forceInline: {
      type: Boolean,
      default: false
    }
  },
  mounted() {
    this.hideTooltip = () => this.isTooltip = false;
    eventHub.$on('hide-tooltip', this.hideTooltip);
  },
  beforeDestroy() {
    eventHub.$off('hide-tooltip', this.hideTooltip);
  },
  methods: {
    toggleTooltip() {
      this.isTooltip = !this.isTooltip;

      if (this.isTooltip) {
        // Delay a frame and update the scroll effect
        setTimeout(() => {
          this.updateScrollEffect({ target: this.$refs.footnoteTooltipWrapper });
        }, 16);
      }
    },
    updateScrollEffect($event) {
      requestAnimationFrame(() => {
        const element = $event.target;
        const parent = element?.parentElement;
        if (!parent) {
          return;
        }

        const limit = element.scrollHeight - 5;
        const scrolled = element.offsetHeight + element.scrollTop;
        parent.style.setProperty('--top-shadow-opacity', element.scrollTop === 0 ? 0 : 1);
        parent.style.setProperty('--bottom-shadow-opacity', scrolled >= limit ? 0 : 1);
      });
    },
  },
  computed: {
    ...mapGetters(['activeCard']),

    isInline() {
      return !this.activeCard.content?.[this.visIndex]?.config?.useFootnoteTooltip || this.forceInline;
    },

    useFootnoteTooltip() {
      return this.activeCard.content?.[this.visIndex]?.config?.useFootnoteTooltip && !this.forceInline;
    },

    footnotes() {
      return this.activeCard.content?.[this.visIndex]?.config?.footnotes ?? [];
    },

    firstFootnote() {
      return this.activeCard.content?.[this.visIndex]?.config?.footnotes?.[0];
    },
  },
};
</script>

<style lang="scss" scoped>
.footnote-holder {
  font-size: rem(11);
  padding: 10px;
  display: flex;
  align-items: center;
  position: relative;

  @include iPadProStyles {
    font-size: rem(14);
  }

  p {
    margin: 0;
    margin-left: 5px;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }

  &__inline {
    // padding: 10px 10px 10px 0;
    display: block;

    p {
      text-overflow: initial;
      white-space: normal;
    }
  }
}

.footnotes {
  &__svg-info {
    width: 20px;
    cursor: pointer;
  }

  &__svg-holder {
    position: relative;
    margin-top: -1px;
  }

  &__backing {
    width: 100%;
    height: 100%;
    position: fixed;
    z-index: 101;
    top: 0;
    left: 0;
  }

  &__tool-tip {
    position: absolute;
    width: rem(300);
    background-color: white;
    border: 2px solid #2d6c87;
    background: #fff;
    border-radius: 15px;
    padding: 16px;
    font-size: rem(12);
    left: 22px;
    bottom: 0;
    z-index: 102;

    @include iPadProStyles {
      width: rem(362);
      font-size: rem(14);
    }

    p {
      margin-bottom: 10px;
      overflow: initial;
      white-space: normal;
    }

    p:last-child {
      margin-bottom: 0;
    }
  }

  &__tooltip-wrapper {
    max-height: 390px;
    overflow: auto;
  }

  &__tooltip-scroll-effect-top-bottom {
    --top-shadow-opacity: 0;
    --bottom-shadow-opacity: 1;

    position: relative;

    &:before, &:after {
      content: '';
      display: block;
      position: absolute;
      width: 100%;
      height: 40px;
      z-index: 1;
      transition: opacity linear .15s;
    }

    &:before {
      top: 0;
      background: linear-gradient(rgba(#fff, 1), rgba(#fff, 0));
      opacity: var(--top-shadow-opacity);
    }

    &:after {
      bottom: 0;
      background: linear-gradient(rgba(#fff, 0), rgba(#fff, 1));
      opacity: var(--bottom-shadow-opacity);
    }
  }
}
</style>
